module.exports = __webpack_public_path__ + "img/rockbase.da97c041.svg";